(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-work-item', {
            parent: 'entity',
            url: '/document-work-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item/document-work-items.html',
                    controller: 'DocumentWorkItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-work-item-detail', {
            parent: 'entity',
            url: '/document-work-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item/document-work-item-detail.html',
                    controller: 'DocumentWorkItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItem');
                    $translatePartialLoader.addPart('workItemType');
                    $translatePartialLoader.addPart('workItemStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentWorkItem', function($stateParams, DocumentWorkItem) {
                    return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-work-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-work-item-detail.edit', {
            parent: 'document-work-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item.new', {
            parent: 'document-work-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seqNo: null,
                                startDate: null,
                                endDate: null,
                                email: null,
                                legalName: null,
                                accessCode: null,
                                note: null,
                                roleName: null,
                                signature: null,
                                signatureContentType: null,
                                signatureImg: null,
                                signatureImgContentType: null,
                                initialImg: null,
                                initialImgContentType: null,
                                pageNo: null,
                                xPos: null,
                                yPos: null,
                                requireTwoStepAuth: null,
                                requireSignedCopy: null,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('document-work-item');
                });
            }]
        })
        .state('document-work-item.edit', {
            parent: 'document-work-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-dialog.html',
                    controller: 'DocumentWorkItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item.delete', {
            parent: 'document-work-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item/document-work-item-delete-dialog.html',
                    controller: 'DocumentWorkItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentWorkItem', function(DocumentWorkItem) {
                            return DocumentWorkItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item', null, { reload: 'document-work-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
